import type {ForestMass} from '@/domain/entities/ForestMass';
import type {InventoryPlot} from '@/domain/entities/InventoryPlot';
import type {CreateInventoryPlot, CutForestMass, UploadForestMass, WeightInventoryPlot} from '@/domain/entities/Op';
import type {OpRepository} from '@/domain/interfaces/OpRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import {toDomain as InventoryPlotMapper} from '@/infrastructure/repositories/inventoryPLot/InventoryPLotMappers';
import {
  cutForestMassMapper,
  uploadForestMassMapper,
  weightInventoryPlotMapper,
} from '@/infrastructure/repositories/op/OpMappers';

export class RestOpRepository implements OpRepository {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly multipartClient: HttpClient,
  ) {}
  cutForestMass = async (domain: CutForestMass): Promise<void> => {
    return this.httpClient.post(`op/cut-forest-mass`, cutForestMassMapper.toDto(domain));
  };
  uploadForestMasses = async (domain: UploadForestMass, file: File): Promise<ForestMass | undefined> => {
    const mapper = uploadForestMassMapper;

    const formData = new FormData();
    formData.append('file', file);
    formData.append('properties_json', JSON.stringify(mapper.toDto(domain)));

    return this.multipartClient.post('op/upload-forest-masses', formData);
  };
  createInventoryPlots = async (domain: CreateInventoryPlot, file: File): Promise<void> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('properties', JSON.stringify(domain));

    return this.multipartClient.post('op/create-inventory-plots', formData);
  };
  weightInventoryPlots = async (domain: WeightInventoryPlot): Promise<InventoryPlot> => {
    const mapper = InventoryPlotMapper;
    const dto = await this.httpClient.post<WeightInventoryPlot, InventoryPlot>(
      `op/weight-inventory-plots`,
      weightInventoryPlotMapper.toDto(domain),
    );
    return mapper(dto);
  };
}
